export const $nodewidth = 200
export const $socketmargin = 6
export const $socketsize = 24
export const $socketcolor = '#ffffff66'
export const $contextColorLight = 'rgba(150,150,150,0.8)'
export const $contextColor = 'rgba(100,100,100,0.8)'
export const $contextColorDark = '#00000055'
export const $contextWidth = '200px'
